import * as React from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import { isPresetColor } from './utils';
const Ribbon = function Ribbon({ className, prefixCls: customizePrefixCls, style, color, children, text, placement = 'end', }) {
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('ribbon', customizePrefixCls);
    const colorInPreset = isPresetColor(color);
    const ribbonCls = classNames(prefixCls, `${prefixCls}-placement-${placement}`, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-color-${color}`]: colorInPreset,
    }, className);
    const colorStyle = {};
    const cornerColorStyle = {};
    if (color && !colorInPreset) {
        colorStyle.background = color;
        cornerColorStyle.color = color;
    }
    return (<div className={`${prefixCls}-wrapper`}>
      {children}
      <div className={ribbonCls} style={Object.assign(Object.assign({}, colorStyle), style)}>
        {text}
        <div className={`${prefixCls}-corner`} style={cornerColorStyle}/>
      </div>
    </div>);
};
export default Ribbon;
